import { render, staticRenderFns } from "./JobSubmissions.vue?vue&type=template&id=cbf08524&"
import script from "./JobSubmissions.vue?vue&type=script&lang=js&"
export * from "./JobSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./JobSubmissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports